import React from 'react';

const Button = (props) => {
    return (
        <button className='text-3xl  text-white w-[32px] h-[32px] rounded-full  md:ml-8 hover:bg-indigo-400 duration-500 items-center'>
            {props.children}
      </button>
    );
};

export default Button;